var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"dialog",attrs:{"visible":_vm.visible,"width":"800px","title":_vm.title},on:{"close":_vm.handleClose}},[_c('el-row',[_c('img',{attrs:{"src":require("../../../assets/dt.jpg"),"width":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }